import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function conversorEntradaSaida(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@conversorEntradaSaida/FIND_CONVERSOR_ENTRADA_SAIDA':
      case '@conversorEntradaSaida/UPDATE_CONVERSOR_ENTRADA_SAIDA':
      case '@conversorEntradaSaida/DELETE_CONVERSOR_ENTRADA_SAIDA':
      case '@conversorEntradaSaida/STORE_CONVERSOR_ENTRADA_SAIDA':
      case '@conversorEntradaSaida/CONVERSORES_ENTRADA_SAIDA_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@conversorEntradaSaida/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@conversorEntradaSaida/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.conversoresEntradaSaida;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@conversorEntradaSaida/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload?.conversorEntradaSaida ?? null;
        break;
      }

      case '@conversorEntradaSaida/SUCCESS_REMOVE': {
        draft.loading = false;
        draft.find = null;
        break;
      }

      case '@conversorEntradaSaida/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = { ...draft.params, ...action.payload.params };
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
